import { cockpitUi } from "./ui/cockpit";
import { intelUi } from "./ui/intel";
import { common } from "./ui/common";
import { chartsUi } from "./ui/charts";
import { market } from "./ui/market";
import { settings } from "./ui/settings";
import { shell } from "./ui/shell";
import { workspaceUi } from "./ui/workspace";

const modules = [common, shell, market, chartsUi, settings, intelUi, cockpitUi, workspaceUi];

export const ui = {
  en: Object.assign({}, ...modules.map((m) => m.en)) as Record<string, string>,
  de: Object.assign({}, ...modules.map((m) => m.de)) as Record<string, string>,
};
